var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33328 15.6666C12.3866 15.6666 15.6666 12.3866 15.6666 8.33331C15.6666 4.27999 12.3866 1 8.33328 1C4.27998 1 1 4.27999 1 8.33331C1 11.44 2.93332 14.1 5.66663 15.1666",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33326 12.9998C10.9106 12.9998 12.9999 10.9105 12.9999 8.33315C12.9999 5.75583 10.9106 3.6665 8.33326 3.6665C5.75595 3.6665 3.66663 5.75583 3.66663 8.33315C3.66663 10.9105 5.75595 12.9998 8.33326 12.9998Z",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3332 15.3333L13.5199 13.52",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.86 14.8063L14.8 15.8663C14.54 16.1263 14.54 16.5463 14.8 16.8063L18.58 20.5863C18.8466 20.853 19.2066 20.9996 19.5799 20.9996C20.3599 20.9996 20.9933 20.3663 20.9933 19.5863C20.9933 19.213 20.8466 18.853 20.5799 18.5863L16.8 14.8063C16.54 14.5463 16.12 14.5463 15.86 14.8063Z",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.35121e18e9badfcb2c5070756480d59c.svg";
export { ForwardRef as ReactComponent };